import  axios from 'common/axios';

const getHttp = function(url, _opts) {
  _opts = _opts || {};
  return function (options) {
    return axios(Object.assign({
      url : url
    }, _opts, options)).then(({data}) => {
      return data.result;
    });
  } 
}

export const getMedia = getHttp('/v2/direction/getMediaDirection');
export const getArtical = getHttp('/v2/direction/getInfoArticleDirection');
export const getKeyword = getHttp('/v2/direction/recommendWord');
export const getRegion = getHttp('/v2/direction/getRegion');
export const getMediaCategory = getHttp('/v2/direction/getMediaCategory');
export const getUnionMediaCategory = getHttp('/v2/direction/unionMediaCategory');
export const getUnionMediaApp = getHttp('/v2/direction/unionMediaApp');

export const getUnionMediaExclude = getHttp('/v2/unionMediaPackage/list');

export const getInterestTag = getHttp('/v2/authority/interestTag');

export const getAppBehave = getHttp('/v2/direction/getAppBehave');

export const getTopApp = function(word) {
  return axios({
    url : '/v2/direction/getTopApp',
    params: {
      name: word
    }
  }).then(({data}) => {
    return data.result;
  });
}
